<template>
    <div class="col-xxl-3 col-xl-4 col-sm-6 box-col-30">
        <div class="card country-sales-view">
            <div class="card-header">
                <h3>Sales By Countries</h3>
            </div>
            <div class="card-body p-0">
                <div class="medium-chart">

                    <apexchart type="radar" height="335" :options="country.options1" :series="country.series"></apexchart>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
var secondary = localStorage.getItem('secondary_color') || '#FFA47A';
export default {
    name: 'salecountryPage',
    data() {
        return {
            country: {
                options1: {
                    chart: {
                        height: 335,
                        type: "radar",
                        toolbar: {
                            show: false,
                        },
                    },

                    stroke: {
                        width: 2,
                        curve: "smooth",
                    },
                    legend: {
                        show: false,
                    },
                    labels: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",],
                    grid: {
                        borderColor: "#d3dbf4",
                    },
                    colors: [secondary],
                    markers: {
                        size: [5, 0],
                        colors: ["#00000000"],
                        strokeColor: secondary,
                        strokeWidth: [3, 0],
                        hover: {
                            size: 5,
                            sizeOffset: 3,
                        },
                    },
                    tooltip: {
                        marker: {
                            show: false,
                        },
                        fixed: {
                            enabled: false,
                            position: "bottomRight",
                            offsetX: 0,
                            offsetY: 0,
                        },
                    },
                    yaxis: {
                        tickAmount: 6,
                        show: false,
                    },
                    responsive: [{
                        breakpoint: 1661,
                        options: {
                            chart: {
                                height: 290,
                            },
                        },
                    },
                    {
                        breakpoint: 420,
                        options: {
                            chart: {
                                height: 260,
                            },
                        },
                    },
                    ],
                },
                series: [{
                    data: [20, 100, 40, 30, 50, 80, 33],
                },],
            }
        }
    }
}
</script>
